import e from "react";
import r from "./index22.mjs";
import t from "./index23.mjs";
const d = ({ description: a, title: n }) => /* @__PURE__ */ e.createElement("div", { className: t.container, "data-testid": "loader" }, /* @__PURE__ */ e.createElement(
  "div",
  {
    "data-testid": "loader-spinner-container",
    className: t.loader_spinner_container
  },
  /* @__PURE__ */ e.createElement(r, null)
), /* @__PURE__ */ e.createElement(
  "div",
  {
    "data-testid": "loader-text-container",
    className: t.loader_text_container
  },
  /* @__PURE__ */ e.createElement("h3", { "data-testid": "loader-title" }, n || I18n.t("booking_engine.information.please_wait")),
  a ? /* @__PURE__ */ e.createElement("p", { "data-testid": "loader-description" }, a) : null
));
export {
  d as Loader
};
